import { useQuery } from "@apollo/client"
import { Icon, MenuItem } from "@blueprintjs/core"
import CustomTooltip from "components/Atoms/CustomTooltip"
import StaticSelector from "components/Atoms/StaticSelector"
import { REFERENCE_GRADES } from "graphql/selector.queries.gql"
import { get } from "lodash-es"
import React from "react"

const disableItem = (selectedItems, item) => {
  return (
    selectedItems && selectedItems.find(si => get(si, "id") === get(item, "id"))
  )
}
const HarvestGradeSelector = ({
  index,
  gradePrices,
  onCompleted,
  gradePrice,
}) => {
  const { data, loading } = useQuery(REFERENCE_GRADES, {
    onCompleted,
  })

  let harvestGrades = get(data, "referenceGrades", [])
  return (
    <StaticSelector
      items={harvestGrades ? harvestGrades : []}
      loading={loading}
      path={`gradePrices.${index}.grade`}
      label={
        <div className="flex items-baseline">
          Grade
          <CustomTooltip
            content={get(gradePrice, "grade.specifications")}
            placement="top"
          >
            <Icon className="ml-2" icon="info-sign" iconSize={13} />
          </CustomTooltip>
        </div>
      }
      itemRenderer={(item, { handleClick, modifiers }) => {
        const grades = gradePrices.map(gp => gp.grade)

        return (
          <MenuItem
            active={modifiers.active}
            key={item.id}
            onClick={handleClick}
            text={item.name}
            disabled={disableItem(grades, item)}
          />
        )
      }}
    />
  )
}

export default HarvestGradeSelector
